import { RouteConstants } from 'config/routes/routeConstants'
import { LayoutContext } from 'context/LayoutContext'
import { ScreenContext } from 'context/ScreenContext'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import basketIcon from '../../../assets/images/shopping-basket.svg'

function CustomBasketIcon({count}) {
const { openPanel } = useContext(LayoutContext)
const { mobile } = useContext(ScreenContext)

const navigate = useNavigate()

const onBasketClick = () =>{
  openPanel('basketPanel')
  if(mobile){
    navigate(RouteConstants.DrawerBasket)
  }
  
}
  return (
    <button className='custom-basket' onClick={onBasketClick}>
        <img className='custom-basket-icon' src={basketIcon} alt='Basket Icon' />
        { count && <span className='custom-basket-count'>{count}</span>}
    </button>
  )
}

export default CustomBasketIcon